const removeTrailingSlash = (value = "") =>
  typeof value === "string" ? value.replace(/\/+$/, "") : value;

export const getEnvVariables = () => {
  return {
    API_URL: removeTrailingSlash(import.meta.env.VITE_APP_API_URL),
    DOMAIN: removeTrailingSlash(import.meta.env.VITE_APP_URL),
    APP_ENV: import.meta.env.VITE_APP_ENV,
    APIKEY: import.meta.env.VITE_APIKEY_GOOGLE,
    GOOGLE_OAUTH_CLIENT_ID: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
    APPLE_SERVICES_ID: import.meta.env.VITE_APPLE_SERVICES_ID,
    // Credenciales de integración Transbank (ver src/lib/transbankCredenciales.js).
    // Únicas usadas por dev/testing; en producción se leen de useMachine().
    CODE_COMERCE_DEV: import.meta.env.VITE_CODE_COMERCE_DEV,
    CODE_STORE_DEV: import.meta.env.VITE_CODE_STORE_DEV,
    API_KEY_DEV: import.meta.env.VITE_API_KEY_DEV,
    CODE_COMERCE_WEBPAY_DEV: import.meta.env.VITE_CODE_COMERCE_WEBPAY_DEV
  }
}